import { render } from "./LimoService.vue?vue&type=template&id=6648d12e&scoped=true"
import script from "./LimoService.vue?vue&type=script&lang=js"
export * from "./LimoService.vue?vue&type=script&lang=js"

import "./LimoService.vue?vue&type=style&index=0&id=6648d12e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6648d12e"]])

export default __exports__